import React, { Component } from 'react';
import CSSModules from 'react-css-modules'
import Helmet from 'react-helmet'
import { Link, GetStartedInput } from '../../components'
import Styles from './WhyGenderEqualityFunds.css'
import config from '../../config'


@CSSModules(Styles, {allowMultiple:true})
export default class WhyGenderEqualityFunds extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const bannerImage = 'walking'
    const bannerHeadline = 'Gender Equality in the Workplace'
    const bannerSubtitle = 'What will it take to reach gender equality in the workplace?'

    return (
      <div>
        <div styleName='image-banner'>
          <div styleName='image-banner-container'>
            <div styleName='image-banner-container-inner'>
              <div styleName={'image-banner-'+bannerImage}>
                <div styleName='image-banner-headline'>{bannerHeadline}</div>
                <div styleName='image-banner-subtitle'>{bannerSubtitle}</div>
              </div>
            </div>
          </div>
        </div>

        <div styleName='page'>
          <div styleName={'container m-b'}>
            <div styleName='container-inner'>
              <Helmet title='Gender Equality in the Workplace'/>

              { /* <div styleName='headline'>
                Gender Equality in the Workplace
              </div> */ }

              <p>Women comprise 47% of the workforce, but <Link xstrong={true} to='https://www.catalyst.org/research/women-ceos-of-the-sp-500/' title='List: Women CEOs of the S&P 500 - Catalyst Research'>only 4.8%</Link> of S&P 500 companies have female CEOs. Men are promoted at <Link xstrong={true} to='https://www.wsj.com/articles/its-time-for-companies-to-try-a-new-gender-equality-playbook-1474963861' title='It’s Time for Companies to Try a New Gender-Equality Playbook - Wall Street Journal'>30% higher rates</Link> than women during their early career stages. Women are paid 79 cents on the dollar of their male colleagues, and it’s <Link xstrong={true} to='https://www.theatlantic.com/business/archive/2016/10/79-cents/504386/' title='About Those 79 Cents - The Atlantic'>even worse</Link> for women of color. Fifty percent of <Link xstrong={true} to='https://www.pewsocialtrends.org/2018/01/09/women-and-men-in-stem-often-at-odds-over-workplace-equity/' title='Women and Men in STEM Often at Odds Over Workplace Equity - Pew Research Center'>women in STEM fields</Link> eventually <Link xstrong={true} to='https://techcrunch.com/2016/04/14/women-in-tech-whats-the-real-problem/' title='https://techcrunch.com/2016/04/14/women-in-tech-whats-the-real-problem/ - TechCrunch'>leave their job</Link> because of hostile work environments. Clearly, we have a long way to go to reach gender equality in the workplace.</p>

              <div styleName='answer-title'>
                But what will it take to reach gender equality in the workplace?
              </div>

              <p>According to the United Nations, <Link xstrong={true} to='https://www.un.org/womenwatch/osagi/conceptsandefinitions.htm' title='Gender Mainstreaming, Concepts and Definitions - United Nations'>gender equality</Link> will be achieved when access to rights, responsibilities or opportunities is unaffected by gender.</p>

              <div styleName='answer-title'>
                What are some of the top <Link xstrong={true} to={config.routes.howitworks}>gender equality issues</Link> still facing women in the workplace?
              </div>

              <ul styleName='answer-list'>
                <li>gender balance of companies board of directors, executive staff, senior management, and employee workforce </li>
                <li>promotion and career development opportunities</li>
                <li>commitment to pay a fair wage to all employees </li>
                <li>equal access to training and career development</li>
                <li>non-discriminatory recruitment policy</li>
                <li>commitment to the safety of employees in the workplace</li>
                <li>commitment to ensure the protection of human rights</li>
                <li>initiatives to reduce trafficking and human rights risks throughout the supply chain</li>
                <li>systems and policies for the reporting of internal ethical compliance complaints without retaliation or retribution</li>
              </ul>

            </div>
          </div>

          <GetStartedInput/>

          <div styleName={'container m-b'}>
            <div styleName='container-inner'>

              <div styleName='answer-title'>
                How can we move the needle on gender equality in the workplace?
              </div>

              <p>One strategy is to exert market pressure on companies to improve their performance on gender issues by encouraging individual and institutional investors to <Link xstrong={true} to={config.links.aysinvest} title='Invest Your Values - As You Sow'>align their actions with their values,</Link> and take responsibility for the investments they own.</p>

              <p>If you want to align your investments with your values, first you have to know what you own. If you’re like most people, though, your investments and retirement plans rely heavily on mutual funds. That makes it nearly impossible to figure out what individual companies you actually own. </p>

              <p><Link xstrong={true} to={config.links.ays} title='As You Sow'><em>As You Sow</em></Link> is changing that, with its suite of free online <Link xstrong={true} to={config.links.aysinvest} title='Invest Your Values - As You Sow'>Invest Your Values</Link> tools. Invest Your Values makes it easy to screen mutual fund holdings against specific environmental, social, and governance issues. This transparency gives investors, for the first time, the ability to apply a values lens in evaluating mutual funds.</p>

              <p><em>As You Sow</em>’s <Link xstrong={true} to={config.routes.home}>Gender Equality Funds</Link> enables individual and institutional investors to apply a gender lens to portfolios invested through mutual funds and exchange-traded funds (ETFs).</p>

              <p>This tool helps:</p>

              <ul styleName='answer-list'>
                <li>drive capital away from funds that hold companies with poor gender scores.</li>
                <li>drive capital to funds whose holdings reflect positive gender policies and parity.</li>
                <li>exert market pressure on companies to improve their performance on gender issues.</li>
              </ul>

              <p>Gender Equality Funds screens the specific holdings of thousands of the most commonly-held U.S. mutual funds against a database detailing individual company performance on 12 key performance indicators. These 12 indicators combine into an overall Gender Equality Portfolio Score for each mutual fund. The tool is very easy to use—users just type in a fund name or ticker symbol to see the fund’s gender score.</p>

              <div styleName='answer-title'>
                Do I have to sacrifice return when I invest with a gender lens?
              </div>

              <p>The short answer is no! According to the US SIF Foundation, gender lens investing can generate financial and social returns. In its <Link xstrong={true} to='https://www.ussif.org/trends' title='US SIF Trends Report - US SIF Foundation'>report,</Link> the foundation tracked data on gender lens investing and identified $868 billion in institutional investor assets under management that take gender lens issues under consideration, more than double the $397 billion identified in 2016.</p>

              <p>Research <Link xstrong={true} to='https://www.catalyst.org/research/women-on-corporate-boards/' title='Quick Take: Women on Corporate Boards - Catalyst Research'>shows</Link> that companies with three or more women serving on corporate boards performed significantly better financially than companies with few or no women on their boards. Companies with the highest percentages of women board directors outperformed those with the least number of women, on average, by 53 percent on return on equity, 42 percent for return on sales and 66 percent for return on invested capital.</p>

              <p>So, what are you waiting for? Check out <Link xstrong={true} to={config.routes.home}>Gender Equality Funds</Link> today, visit <em>As You Sow</em>’s <Link xstrong={true} to={config.links.blog} title='Gender Equality Blog - As You Sow'>gender equality blog</Link>, and <Link xstrong={true} to={config.links.signup} title='Sign up for updates - Invest You Values'>sign up</Link> for updates.</p>

              <p>Gender Equality Funds is <em>As You Sow</em>’s fifth <Link xstrong={true} to={config.links.aysinvest} title='Invest Your Values - As You Sow'>Invest Your Values</Link> online tool, joining <Link xstrong={true} to='https://fossilfreefunds.org' title=''>Fossil Free Funds</Link>, <Link xstrong={true} to='https://deforestationfreefunds.org' title=''>Deforestation Free Funds</Link>, <Link xstrong={true} to='https://tobaccofreefunds.org' title=''>Tobacco Free Funds</Link>, and <Link xstrong={true} to='https://weaponfreefunds.org' title=''>Weapon Free Funds</Link>. <Link xstrong={true} to={config.links.signup} title='Sign up for updates - Invest You Values'>Keep up to date</Link> on gender equality issues in the workplace.</p>
            </div>
          </div>
          <GetStartedInput/>
        </div>
      </div>
    )
  }
}
